// extracted by mini-css-extract-plugin
module.exports = {"root":"TabsWithCards_root__tVAb6"};